import axios from 'axios';
import fecha from 'fecha';
import JSONP from 'jsonp';

import jQuery from 'jquery';

var $ = jQuery;

import CreekMainCSS from '../static/css/creek.css';

const CreekConfigPlugin = {
  
  install(Vue, options) {

    if(options.globalVar){
      var _scope = options.globalVar;
    }else{
      var _scope = window.top.document;
    }

    if(typeof _scope.Creek == "undefined"){
      _scope.Creek = {};
    }

    _scope.Creek.config = options;

    require('../init');

    // console.log(Creek);

    // Make Creek accessible in all Vue instances
    Vue.prototype.Creek = _scope.Creek;

    // Add some global tools
    Vue.prototype.fecha = fecha;
    Vue.prototype.JSONP = JSONP;

    //Load the station API data to get the stream.
    var initialLoad = function(Creek, data){

      _scope.Creek.debug.log("Loading Station API and stream addresses.");

      Vue.prototype.JSONP(_scope.Creek.config.content.baseURLForAPI + "/api/station", function(err, data){

        console.log(data);

        _scope.Creek.debug.log("Received Station API.")
        _scope.Creek.debug.log(data)

        _scope.Creek.API.Station = data;

        // Get Live URL
        var streams = _scope.Creek.API.Station.streams;
        var stream = streams.website || streams.main;
        _scope.Creek.audio.live.URL = stream.url;
     
      })

    }

    initialLoad();

  }

};

export default CreekConfigPlugin;